import Hero from "../components/home/Hero";
import MethodComparison from "../components/home/MethodComparison";
import GreenCertified from "../components/home/GreenCertified";
import EditorsChoice from "../components/home/EditorsChoice";
import HowItWorks from "../components/home/HowItWorks";
import ProviderDirectory from "../components/home/ProviderDirectory";
import CitiesCategories from "../components/home/CitiesCategories";
import FaqCta from "../components/home/FaqCta";

export default function Home() {
  return (
    <main>
      <Hero />
      <MethodComparison />
      <ProviderDirectory />
      <GreenCertified />
      <EditorsChoice />
      <HowItWorks />
      <CitiesCategories />
      <FaqCta />
    </main>
  );
}
